import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const PollsStatsIcon = ({ color = '#000', size = 'm24', ...attr }) => {
  return (
    <svg {...iconSizes[size]} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <title>Polls Stats Icon</title>
      <path fillRule="evenodd" clipRule="evenodd" d="M22 12H12V15H22V12ZM12 10H10V12V15V17H12H22H24V15V12V10H22H12ZM12 22V25H36V22H12ZM12 20H10V22V25V27H12H36H38V25V22V20H36H12ZM12 33H27V36H12V33ZM10 31H12H27H29V33V36V38H27H12H10V36V33V31Z" fill={color} />
    </svg>
  );
};

export default PollsStatsIcon;
